import s from './Loader.module.css';

export default function Loader() {
  return (
    <>
      <img
        src="https://i.postimg.cc/L627JjpR/spiner-cat.gif"
        border="0"
        alt="spiner-cat"
        className={s.spinerCat}
      />
    </>
  );
}
